import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "448pt",
	viewBox: "0 0 448 448",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M314.375 144h-180.75L224 221.465zm0 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M224 240a8 8 0 0 1-5.207-1.93L120 153.39V304h208V153.39l-98.793 84.68A8 8 0 0 1 224 240m0 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M224 0C100.29 0 0 100.29 0 224s100.29 224 224 224 224-100.29 224-224C447.86 100.348 347.652.14 224 0m120 312a8 8 0 0 1-8 8H112a8 8 0 0 1-8-8V136a8 8 0 0 1 8-8h224a8 8 0 0 1 8 8zm0 0" })
	]
});
export default SvgEmail;
